import React, { useState } from 'react';

const UnsubscribePage = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    email: ''
  });
  const [status, setStatus] = useState('idle'); // 'idle', 'loading', 'success', 'error'
  const [message, setMessage] = useState('');

  const { fullName, email } = formData;

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('loading');
    setMessage('');

    // Basic validation
    if (!fullName || !email) {
      setStatus('error');
      setMessage('Please fill in all fields.');
      return;
    }

    // Simple email validation
    const emailRegex = /\S+@\S+\.\S+/;
    if (!emailRegex.test(email)) {
      setStatus('error');
      setMessage('Please enter a valid email address.');
      return;
    }

    // --- THIS IS WHERE YOU WOULD CONNECT TO A BACKEND SERVICE ---
    // You would send the email to your service (e.g., Mailchimp, SendGrid) to handle the unsubscription.
    console.log('Unsubscribing user:', formData);

    // Simulate a network request to the backend
    setTimeout(() => {
      // Simulate a successful unsubscribe
      setStatus('success');
      setMessage(`You have been successfully unsubscribed. We're sorry to see you go, ${fullName}.`);
      // Clear the form on success
      setFormData({ fullName: '', email: '' });

      // To simulate an error, you could use this instead:
      /*
      setStatus('error');
      setMessage('We could not find that email address in our system. Please check and try again.');
      */
    }, 1500); // Simulate 1.5 second delay
  };

  return (
    // Main container with a light background and centering
    <div className="bg-gray-100 min-h-screen flex justify-center items-center p-4">
      {/* Form card */}
      <div className="bg-white p-8 md:p-12 rounded-xl shadow-xl w-full max-w-md text-center">
        <h1 className="text-3xl font-bold text-gray-800 mb-4">We're Sorry to See You Go</h1>
        <p className="text-gray-600 mb-8">
          We understand if you no longer wish to receive our emails. Fill out the form below to be removed from our mailing list.
        </p>

        {/* Show success or error message */}
        {status === 'success' ? (
          <div className="p-4 bg-green-100 border border-green-400 text-green-700 rounded-lg">
            <p className="font-medium">{message}</p>
            <p className="text-sm mt-2">This change may take a few minutes to take effect.</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-6">
            {/* Full Name Field */}
            <div className="text-left">
              <label htmlFor="fullName" className="block text-sm font-semibold text-gray-700 mb-2">
                Full Name
              </label>
              <input
                type="text"
                id="fullName"
                name="fullName"
                value={fullName}
                onChange={handleChange}
                placeholder="Jane Doe"
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#fe7590] focus:border-transparent transition"
                required
              />
            </div>

            {/* Email Field */}
            <div className="text-left">
              <label htmlFor="email" className="block text-sm font-semibold text-gray-700 mb-2">
                Email Address
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={email}
                onChange={handleChange}
                placeholder="jane.doe@example.com"
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#fe7590] focus:border-transparent transition"
                required
              />
            </div>

            {/* Status Message for errors */}
            {status === 'error' && (
              <div className="p-4 bg-red-100 border border-red-400 text-red-700 rounded-lg text-sm">
                {message}
              </div>
            )}

            {/* Submit Button */}
            <button
              type="submit"
              className="w-full bg-[#fe7590] text-white font-bold py-3 px-4 rounded-lg hover:bg-red-700 transition disabled:bg-gray-400 disabled:cursor-not-allowed"
              disabled={status === 'loading'}
            >
              {status === 'loading' ? 'Processing...' : 'Unsubscribe Me'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default UnsubscribePage;